import { render, staticRenderFns } from "./stripo.vue?vue&type=template&id=054521f3"
import script from "./stripo.vue?vue&type=script&lang=js"
export * from "./stripo.vue?vue&type=script&lang=js"
import style0 from "./stripo.vue?vue&type=style&index=0&id=054521f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports